import { render, staticRenderFns } from "./DialogPageMessage.vue?vue&type=template&id=93db9cf6"
import script from "./DialogPageMessage.vue?vue&type=script&lang=js"
export * from "./DialogPageMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports